import {PayloadAction} from "../payload-action.interface";
import {TemplateEntity} from "./template.entity";
import {TemplateActions} from "./template.actions";


export function TemplateReducer(state: Array<TemplateEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case TemplateActions.REMOVE:
      return removeTemplate(state, action.payload);
    case TemplateActions.ADD:
    case TemplateActions.SET:
      newState = removeTemplate(state, action.payload._id);
      return addTemplate(newState, action.payload);
    case TemplateActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addTemplate(state: Array<TemplateEntity>, template: TemplateEntity): Array<TemplateEntity> {
  return [...state, template];
}

function removeTemplate(state: Array<TemplateEntity>, id: string): Array<TemplateEntity> {
  return state.filter((template) => template._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/template/template.reducer.ts